import { get } from '../utils/api'

export const removeMainTransClass = () => {
  const elements = document.querySelectorAll('.show');
  elements.forEach(element => {
    element.classList.remove('show');
});
};

const addClassWithDelay = (selector, className, delay) => {
  setTimeout(() => {
    const element = document.querySelector(selector);
    if(element){
      element.classList.add(className);
    }
  }, delay);
};

const getPcPageAnimationClass = (page) => {
  switch (page) {
    case 0:
      break;
    case 1:
      addClassWithDelay('#main-prd-intro-content', 'show', 500);
      addClassWithDelay('#main-prd-intro-img', 'show', 500);
      addClassWithDelay('#prd-card-0', 'show', 600);
      addClassWithDelay('#prd-card-1', 'show', 500);
      addClassWithDelay('#prd-card-2', 'show', 500);
      addClassWithDelay('#prd-card-3', 'show', 600);
      break;
    case 2:
      addClassWithDelay('#sol-circle-card-0', 'show', 500);
      addClassWithDelay('#sol-circle-card-1', 'show', 600);
      addClassWithDelay('#sol-circle-card-2', 'show', 700);
      addClassWithDelay('#sol-circle-card-3', 'show', 800);
      break;
    case 3:
      addClassWithDelay('#main-cert-card-0', 'show', 500);
      addClassWithDelay('#main-cert-card-1', 'show', 600);
      addClassWithDelay('#main-cert-card-2', 'show', 700);
      addClassWithDelay('#main-cert-card-3', 'show', 800);
      addClassWithDelay('#main-cert-more-btn', 'show', 1000);
      break;
    case 4:
      addClassWithDelay('#main-pf-card-0', 'show', 500);
      addClassWithDelay('#main-pf-card-1', 'show', 550);
      addClassWithDelay('#main-pf-card-2', 'show', 600);
      addClassWithDelay('#main-pf-card-3', 'show', 650);
      addClassWithDelay('#main-pf-card-4', 'show', 700);
      addClassWithDelay('#main-pf-card-5', 'show', 750);
      addClassWithDelay('#main-pf-card-6', 'show', 800);
      addClassWithDelay('#main-pf-card-7', 'show', 850);
      addClassWithDelay('#main-pf-more-btn', 'show', 1000);
      break;
    case 5:
      addClassWithDelay('.circle1', 'show', 500);
      addClassWithDelay('.circle2', 'show', 600);
      addClassWithDelay('.circle3', 'show', 700);
      addClassWithDelay('.main-rn-field-0', 'show', 500);
      addClassWithDelay('.main-rn-field-1', 'show', 500);
      addClassWithDelay('.main-rn-field-2', 'show', 500);
      addClassWithDelay('.main-rn-field-3', 'show', 500);
      addClassWithDelay('.main-rn-field-4', 'show', 500);
      break;
    case 6:
      addClassWithDelay('#main-nt-div-0', 'show', 500);
      addClassWithDelay('#main-nt-div-1', 'show', 700);
      addClassWithDelay('#main-nt-div-2', 'show', 900);
      addClassWithDelay('#main-nt-div-3', 'show', 1100);
      addClassWithDelay('#main-nt-more-btn', 'show', 1300);
      break;
    case 7:
      addClassWithDelay('#main-cont-div-0', 'show', 500);
      addClassWithDelay('#main-cont-div-1', 'show', 600);
      addClassWithDelay('#main-cont-div-2', 'show', 700);
      break;
    default:
      return "";
  }
};

const getMobilePageAnimationClass = (page) => {
  switch (page) {
    case 0:
      break;
    case 1:
      addClassWithDelay('#main-prd-intro-content', 'show', 200);
      addClassWithDelay('#main-prd-intro-img', 'show', 200);
      addClassWithDelay('#prd-card-0', 'show', 200);
      addClassWithDelay('#prd-card-1', 'show', 300);
      addClassWithDelay('#prd-card-2', 'show', 400);
      addClassWithDelay('#prd-card-3', 'show', 500);
      break;
    case 2:
      addClassWithDelay('#sol-circle-card-0', 'show', 300);
      addClassWithDelay('#sol-circle-card-1', 'show', 400);
      addClassWithDelay('#sol-circle-card-2', 'show', 500);
      addClassWithDelay('#sol-circle-card-3', 'show', 600);
      break;
    case 3:
      addClassWithDelay('#main-cert-card-0', 'show', 200);
      addClassWithDelay('#main-cert-card-1', 'show', 200);
      addClassWithDelay('#main-cert-card-2', 'show', 200);
      addClassWithDelay('#main-cert-card-3', 'show', 200);
      addClassWithDelay('#main-cert-more-btn', 'show', 300);
      break;
    case 4:
      addClassWithDelay('#main-pf-card-0', 'show', 200);
      addClassWithDelay('#main-pf-card-1', 'show', 200);
      addClassWithDelay('#main-pf-card-2', 'show', 200);
      addClassWithDelay('#main-pf-card-3', 'show', 200);
      addClassWithDelay('#main-pf-more-btn', 'show', 300);
      break;
    case 5:
      addClassWithDelay('.circle1', 'show', 200);
      addClassWithDelay('.circle2', 'show', 250);
      addClassWithDelay('.circle3', 'show', 300);
      addClassWithDelay('.main-rn-field-0', 'show', 350);
      addClassWithDelay('.main-rn-field-1', 'show', 350);
      addClassWithDelay('.main-rn-field-2', 'show', 350);
      addClassWithDelay('.main-rn-field-3', 'show', 350);
      addClassWithDelay('.main-rn-field-4', 'show', 350);
      break;
    case 6:
      addClassWithDelay('#main-nt-div-0', 'show', 200);
      addClassWithDelay('#main-nt-div-1', 'show', 300);
      addClassWithDelay('#main-nt-div-2', 'show', 400);
      addClassWithDelay('#main-nt-div-3', 'show', 500);
      addClassWithDelay('#main-nt-more-btn', 'show', 600);
      break;
    case 7:
      addClassWithDelay('#main-cont-div-0', 'show', 200);
      addClassWithDelay('#main-cont-div-1', 'show', 300);
      addClassWithDelay('#main-cont-div-2', 'show', 400);
      break;
    default:
      return "";
  }
};

export const animationController = (currentPage, type) => {
  if(type === 'P') {
    getPcPageAnimationClass(currentPage);
  } else if(type === 'M') {
    getMobilePageAnimationClass(currentPage);
  }
};

export const fetchPopupListData = async () => {
  try {
    const response = await get('/main/popup/list');
    return response;
  } catch (error) {
    console.log(error);  
    return [];
  };
};